<template>
  <div class="image-upload">
    <div
      v-for="(item, index) in itemValue" 
      :key="index"
      class="preview-item">
      <img class="preview-img" :src="item" @click="previewImg(item)" />
      <div class="preview-bottom" v-if="!readonly">
        <van-icon class="icon" name="delete-o" @click="delImage(index)" />
      </div>
    </div>
    <div class="upload-btn" v-if="!readonly && itemValue.length < maxCount" @click="uploadImg()">
      <van-icon 
        v-if="!uploading"
        class="icon" 
        name="plus" />
      <van-loading 
        v-else
        class="loading-spin"  
        size="18px"
      ></van-loading>
      <p class="text">上传图片</p>
    </div>
  </div>
</template>

<script>
import { api } from "@/utils/fetch.js";
import { Toast, Uploader, Icon, Loading, ImagePreview } from 'vant';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      uploading: false
    };
  },
  computed: {
    maxCount() {
      const count = this.item?.limit_count?.max || 9;
      return count;
    }
  },
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Loading.name]: Loading
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      this.itemValue = this.submitValue?.value || [];
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    },
    delImage(index) {
      this.itemValue.splice(index, 1);
      this.onValueChange();
    },
    // 查看图片
    viewImg (url) {
      window.wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: this.imgList // 需要预览的图片http链接列表
      })
    },
    // 调用 拍照或从手机相册中选图接口
    uploadImg () {
      window.wx.chooseImage({
        count: this.maxCount - this.itemValue.length,
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: ({ localIds }) => {
          this.uploadBefore(localIds)
        }
      })
    },
    async uploadBefore (localIds) {
      this.uploading = true;
      for (let i = 0; i < localIds.length; i++) {
        const localId = localIds[i]
        try {
          const res = await this.uploadAfter(localId)
          this.itemValue.push(res);
        } catch (e) {
          
        }
      }
      this.uploading = false;
      this.onValueChange();
    },
    // 上传照片
    uploadAfter (localId) {
      return new Promise((resolve, reject) => {
        window.wx.uploadImage({
          localId,
          isShowProgressTips: 0,
          success: (res) => {
            const { serverId } = res;
            const formData = new FormData();
            formData.append('media_id', serverId);
            api.UploadImage(formData).then((res) => {
              console.log('图片上传：', res);
              resolve(res.image_url);
            }).catch((e) => {
              Toast('uploadImage Error: storage to Host')
              reject(e)
            })
          },
          fail: (e) => {
            Toast('uploadImage Error: storage to weixin')
            reject(e)
          }
        })
      })
    },
    previewImg(img) {
      ImagePreview([img]);
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.image-upload {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  .upload-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: @desc-color-1;
    width: 100px;
    height: 100px;
    background-color: #f7f8fa;
    border: dashed 1px #d9d9d9;
    border-radius: 4px;
    box-sizing: border-box;
    .icon {
      font-size: @font-size-1;
    }
    .loading-spin {
      color: var(--theme-main-color);
    }
    .text {
      font-size: @font-size-3;
      margin-top: 4px;
    }
  }
  .preview-item {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    margin-right: 12px;
    margin-bottom: 12px;
    .preview-img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
    }
    .preview-bottom {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 24px;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        color: #fff;
        font-size: @font-size-1;
      }
    }
    .del-btn {
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background-color: rgba(0,0,0,0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 2px;
      right: 2px;
      .icon {
        font-size: @font-size-2;
        color: #fff;
      }
    }
  }
  
}


</style>
